<highcharts-chart class="charts_h mt-0" [Highcharts]="highcharts" [options]="chartOptions"
    class="w-100 d-block charts_h">
</highcharts-chart>